import * as React from 'react';
import { useSelector } from 'react-redux';
import { EMediaType, TMedia } from 'shared/components/NewbuildingGallery';
import { TourSlideContainer } from 'shared/containers/TourSlideContainer';
import { selectNewbuildingTour } from 'shared/selectors/offerData/tour/selectNewbuildingTour';
import { selectNewbuildingTourBannerImageUrl } from 'shared/selectors/offerData/tour/selectNewbuildingTourBannerImageUrl';

export const use3D = (): TMedia | null => {
  const tour = useSelector(selectNewbuildingTour);
  const thumbnailSrc = useSelector(selectNewbuildingTourBannerImageUrl);

  return React.useMemo<TMedia | null>(() => {
    if (!tour) {
      return null;
    }

    return tour && thumbnailSrc
      ? {
          type: EMediaType.Tour,
          component: <TourSlideContainer />,
          thumbnailSrc,
        }
      : null;
  }, [thumbnailSrc, tour]);
};
